// ====================================================
// More Templates: https://www.ebenmonney.com/templates
// Email: support@ebenmonney.com
// ====================================================

import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {

  public static readonly CURRENT_USER = 'current_user';
  public static readonly ACCESS_TOKEN = 'access_token';
  public static readonly REFRESH_TOKEN = 'refresh_token';
  public static readonly TOKEN_EXPIRES_IN = 'expires_in';

  public static readonly DELEGATION_USER = 'delegation_user';
  public static readonly DELEGATION_ACCESS_TOKEN = 'delegation_access_token';
  public static readonly DELEGATION_REFRESH_TOKEN = 'delegation_refresh_token';
  public static readonly DELEGATION_TOKEN_EXPIRES_IN = 'delegation_expires_in';

  public static readonly REMEMBER_ME = 'remember_me';

  public static readonly HOME_URL = 'home_url';
}
